import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import {
  generateModuleCertificateUrl,
  getModulesDetails,
} from '../../../../../services/apiService';

const certiCharCount = 60;

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

function Module({ goalType, userId }) {
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      if (goalType && userId) {
        const response = await getModulesDetails(goalType, userId);
        setRowData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };
  const handleGenerateCertificate = async (data) => {
    try {
      setLoading(true);
      const payload = {
        userId: userId,
        courseId: data?.courseId,
        moduleId: data?.id,
      };

      const response = await generateModuleCertificateUrl(payload);

      if (response?.successful === true) {
        await fetchData();
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Error Occured');
    } finally {
      setLoading(false);
    }
  };

  const columnDefs = [
    { field: 'id', hide: true },

    { field: 'name', headerName: 'Name' },
    {
      field: 'progress',
    },
    { field: 'runningAvg', headerName: 'Running Average' },
    { field: 'finalAvg', headerName: 'Final Average' },
    { field: 'workload', headerName: 'Work Load' },
    { field: 'credits', headerName: 'Credits' },
    {
      field: 'certificateLink',
      width: 400,

      cellRenderer: (params) => {
        return params?.data?.progress >= 100 && params?.value === null ? (
          <button
            style={{
              fontSize: 13, fontWeight: 500, padding: '4px 8px', borderRadius: 4, cursor: loading ? 'not-allowed' : 'pointer',
              backgroundColor: 'var(--card-background, #fff)',
              color: loading ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)',
              border: `1px solid ${loading ? 'var(--text-muted, #9CA3AF)' : 'var(--primary-main, #60A5FA)'}`,
              opacity: loading ? 0.5 : 1,
            }}
            onClick={() => {
              handleGenerateCertificate(params.data);
            }}
            disabled={loading}
          >
            Generate Certificate
          </button>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', color: 'var(--primary-main, #2563EB)', height: '100%' }}>
            {params.value && (
              <a
                href={params.value}
                target='_blank'
                rel='noreferrer'
                style={{ display: 'flex', alignItems: 'center', fontSize: 13, fontWeight: 400, width: '100%', wordBreak: 'break-all', color: 'var(--primary-main, #2563EB)' }}
              >
                {params.value && params.value.length > certiCharCount
                  ? params.value.substring(0, certiCharCount) + '...'
                  : params.value}
              </a>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, [goalType, userId]);

  return (
    <div>
      <div
        className='ag-theme-alpine h-96  w-full'
        style={{ height: '490px' }}
      >
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
}

export default Module;
